import {fetchHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";

export const geoService = {
    fetchVilles,
};

function fetchVilles() {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_VILLES;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
					return data["hydra:member"]
				});
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
